import * as React from "react";
import { useState } from "react";
// import { RouteComponentProps } from "react-router-dom";
import { TemplateSub } from "../../../../../components/layouts/TemplateSub";
import NewButton from "../../../../../components/uiMerge/newButton";
import { Field, Form, Formik } from "formik";
import { SuccessModal } from "../../../../../components/modals/sucessModal";
import * as ROUTES from "../../../../../constants/routes";
import { InputOTPField } from "../../../../shared/InputOTPField";
import { 
  UpdatePinController, 
  ValidatePinController 
} from "@njoy/controller";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ToastMessage from "../../../../../hooks/useToast";
import { InputPinField } from "src/modules/shared/InputPinField";

interface PinFormValues {
  currentPin: string;
  newPin: string;
  confirmPin: string;
}

export const ChangePin: React.FC = () => {
  const [step, setStep] = useState<"new" | "confirm" | "current">("current");
  const [tempPin, setTempPin] = useState("");
  const [visible, setVisible] = useState(false);

  return (
    <TemplateSub
      page={step === "new" ? "Change PIN" : step === "current" ? "Current PIN" : "Confirm PIN"}
    >
    <ToastContainer />
    <UpdatePinController>
      {({ submitUpdatePin  }) => (
        <ValidatePinController>
          {({submitValidatePin, error}) => {
            return(
              <>
                <Formik<PinFormValues>
                  initialValues={{ currentPin: "", newPin: "", confirmPin: "" }}
                  onSubmit={async (values, { setSubmitting, setErrors, resetForm, setFieldValue }) => {
                    setSubmitting(true);

                    if(step === "current" && values.currentPin.length < 4) {
                      setErrors({ currentPin: "Pin must be 4 digits" });
                      setSubmitting(false);
                      return;
                    }

                    if(step === "new" && values.newPin.length < 4) {
                      setErrors({ newPin: "Pin must be 4 digits" });
                      setSubmitting(false);
                      return;
                    }

                    if(step === "confirm" && values.confirmPin.length < 4) {
                      setErrors({ confirmPin: "Pin must be 4 digits" });
                      setSubmitting(false);
                      return;
                    }

                    if(step === "current") {
                      // Mock pin validation - accept "1234" as valid current pin
                      const errors = await submitValidatePin({ 
                        pin: values.currentPin
                      });

                      if(errors) {
                        ToastMessage("error", errors.pin || errors.user);
                      }

                      if(!errors) {
                        setStep("new");
                      }

                    } else if (step === "new") {
                      // setFieldValue("newPin", "");
                      // setFieldValue("confirmPin", "");
                      // resetForm();
                      // store first pin and move to confirm step
                      if(values.newPin === values.currentPin) {
                        setErrors({ newPin: "New pin must not match old pin" });
                        return;
                      }
                      setTempPin(values.newPin);
                      setStep("confirm");
                    } else {
                      
                      if (values.confirmPin !== tempPin) {
                        setErrors({ confirmPin: "Pins do not match" });
                        setSubmitting(false);
                        return;
                      }

                      const error = await submitUpdatePin({
                        input: {pin: values.confirmPin}
                      });

                      if(!error) {
                        ToastMessage("success", "User pin updated successfully!");
                        setVisible(true);
                      } else {
                        ToastMessage("error", error.pin || error.user);
                        setVisible(true);
                      }

                      // if(res?.data?.updatePin?.errors === null) {
                      //   ToastMessage("success", res.data?.updatePin?.message);
                      //   setVisible(true);
                      // } else {
                      //   console.log(res)
                      //   // ToastMessage("error", res.data?.errors[0].message);
                      //   ToastMessage("error", "Failed to update PIN");
                      // }
                    }

                    // setFieldValue("currentPin", "");
                    setSubmitting(false);
                  }}
                >
                  {({ isSubmitting, handleSubmit }) => (
                    <Form
                      onSubmit={handleSubmit}
                      className="flex flex-col px-[1rem] mt-8 flex-1 h-full"
                    >
                      <p className="w-full !mb-6 text-[#EAEAEA] text-[16px] text-center">
                        {step === "new"
                          ? "Type in your new PIN to proceed."
                          : step === "confirm" 
                          ? "Confirm your new 4-digit PIN"
                          : "Enter your current PIN to proceed."
                        }
                      </p>

                      {step === "current" && (
                        <Field
                          name="currentPin"
                          component={InputPinField}
                          otpLength={4}
                        />
                      )}

                      {step === "new" && (
                        <Field
                          name="newPin"
                          component={InputOTPField}
                          otpLength={4}
                        />
                      )}

                      {step === "confirm" && (
                        <Field
                          name="confirmPin"
                          component={InputOTPField}
                          otpLength={4}
                        />
                      )}
                      

                      <div className="mt-auto mb-8">
                        <NewButton
                          loading={isSubmitting}
                          fullWidth
                          variant="primary"
                          type="submit"
                          className="login-form-button"
                        >
                          {step === "new" ? "Continue" : step === "confirm" ? "Save Changes" : "Validate"}
                        </NewButton>
                      </div>
                    </Form>
                  )}
                </Formik>

                <SuccessModal
                  visible={visible}
                  onCancel={() => setVisible(false)}
                  caption="Your pin has been changed successfully."
                  onClick={() => {
                    setVisible(false);

                    window.location.replace(ROUTES.ACCOUNT_DETAILS);
                  }}
                />
              </>
            )
          }}
        </ValidatePinController>
      )}
    </UpdatePinController>
    </TemplateSub>
  );
};
